import request from "@/utils/request";

export function germplasmGet(params) {
    return request({
        url: "/api/services/app/Germplasm/Get",
        method: "GET",
        params
    });
}

export function germplasmGetBySpeciesChart(params) {
    return request({
        url: "/api/services/app/Germplasm/GetGermplasmBySpeciesChart",
        method: "GET",
        params
    });
}

export function germplasmGetAllForDropdown() {
    return request({
        url: "/api/services/app/Germplasm/GetAllForDropDown",
        method: "GET"
    });
}

export function germplasmCreate(data) {
    return request({
        url: "/api/services/app/Germplasm/Create",
        method: "POST",
        data
    });
}

export function germplasmUpdate(data) {
    return request({
        url: "/api/services/app/Germplasm/Update",
        method: "PUT",
        data
    });
}

export function germplasmDelete(params) {
    return request({
        url: "/api/services/app/Germplasm/Delete",
        method: "DELETE",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/germplasm.js